<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">库区管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建故障</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.DeviceName"
        clearable
        placeholder="请输入设备编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        v-model="searchData.FaultDate"
        type="monthrange"
        style="width: 300px; margin-left: 10px"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="故障编号" align="center" prop="Code">
        </el-table-column>
        <el-table-column label="故障设备编号" align="center" prop="DeviceCode">
        </el-table-column>
        <el-table-column label="故障设备名称" align="center" prop="device_name">
        </el-table-column>
        <el-table-column label="故障类型" align="center" prop="FaultTypeName">
        </el-table-column>
        <el-table-column label="故障日期" align="center" prop="FaultDate">
          <template slot-scope="scope">
            {{
              scope.row.FaultDate
                ? moment(scope.row.FaultDate).format('YYYY-MM-DD HH:mm')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="State">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.State == '0'">待处理</el-tag>
            <el-tag type="success" v-if="scope.row.State == '1'">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提报人" align="center" prop="FaultUserName">
        </el-table-column>
        <el-table-column label="工单编号" align="center" prop="WorkOrderCode">
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleSubmit(scope.row, false)"
              v-if="scope.row.State == '0'"
              >派单</el-button
            >
            <el-button
              type="text"
              @click="handleSubmit(scope.row, true)"
              v-if="scope.row.State == '0'"
              >外委</el-button
            >
            <el-button
              type="text"
              @click="handleEdit(scope.row)"
              v-if="scope.row.State == '0'"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleView(scope.row)"
              v-if="scope.row.State == '1'"
              >详情</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              v-if="scope.row.State == '0'"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      moment,
      searchData: {
        DeviceName: '',
        FaultDate: [],
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'FaultDate', [firstDay, lastDay])
      }
    },
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/Base_DeviceTreeManage/Device_Fault/ExportToExcel?DeviceType=${
            this.devTreeSearch.DeviceType || ''
          }&BuildingId=${
            this.devTreeSearch.BuildingId || ''
          }&InstallationArea=${
            this.devTreeSearch.InstallationArea || ''
          }&DeviceName=${this.searchData.DeviceName}&FaultDate=${
            this.searchData.FaultDate ? this.searchData.FaultDate.join(',') : ''
          }`,
        '故障记录',
        '.xlsx',
        'get'
      )
    },
    selectable(row) {
      if (row.State == '0') {
        return true
      } else {
        return false
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_Fault/GetFaultDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'DeviceName',
              Keyword: this.searchData.DeviceName,
            },
            {
              Condition: 'FaultDate',
              Keyword: this.searchData.FaultDate
                ? this.searchData.FaultDate.join(',')
                : '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('提报故障')
    },
    handleSubmit(row, isExternal) {
      if (isExternal) {
        this.$refs.EditForm.openForm('外委', row, null, true)
      } else {
        this.$refs.EditForm.openForm('派单', row, null, true)
      }
      return
      this.$confirm(`此操作将提报故障到工单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_Fault/SubmitFaultData', {
              id: row.Id,
            })
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('提报成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该故障单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base_DeviceTreeManage/Device_Fault/DeleteDeviceFaultData',
              ids
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑故障', row)
    },
    handleView(row) {
      this.$refs.EditForm.openForm('故障详情', row, null, false, true)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
